import { defineComponent as _defineComponent } from 'vue'
import { TVulnerabilityProofOfConcept, TVulnerabilitySeverity } from '../../models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityPOC',
  props: {
    proofOfConcepts: null,
    severity: null
  },
  setup(__props: any) {

const props = __props as {
  proofOfConcepts: TVulnerabilityProofOfConcept[];
  severity: TVulnerabilitySeverity;
};



function getSeverityColorClass(severity: TVulnerabilitySeverity): string {
  if (severity === 'low') return 'tw:bg-vuln-low';
  if (severity === 'medium') return 'tw:bg-vuln-medium';
  return 'tw:bg-vuln-high';
}

return { __sfc: true,props, getSeverityColorClass }
}

})